import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '../../../../tooltip/tooltip';
import { InlineIcon } from '../../../../inline-icon/inline-icon';
import EmbedIcon from '../../../../../icons/compiled/components/EmbedIcon';
import parentStyles from '../styles.scss';
import styles from './styles.scss';
export class EmbedButton extends React.Component {
    constructor() {
        super(...arguments);
        this.handleClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.props.onClick();
        };
    }
    render() {
        const { dataHook, className, ariaLabel, disabled, tooltip } = this.props;
        return (React.createElement(Tooltip, { content: tooltip },
            React.createElement("button", { "data-hook": dataHook, className: `${styles.icon} ${className}`, "aria-hidden": disabled, disabled: disabled, onClick: this.handleClick, "aria-label": ariaLabel },
                React.createElement(InlineIcon, { className: `${parentStyles.icon} ${styles.icon}`, icon: React.createElement(EmbedIcon, null) }))));
    }
}
EmbedButton.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    tooltip: PropTypes.node,
    onClick: PropTypes.func,
    ariaLabel: PropTypes.string,
    disabled: PropTypes.bool,
};
//# sourceMappingURL=embed-button.js.map